import { strict } from "assert";
import * as React from "react";

const { useEffect, useRef, useState } = React;

export function IsMobileResize() {
    const [width, setWidth] = useState<number>(0);

    useEffect(() => {
        function handleWindowSizeChange() {
          setWidth(window.innerWidth);
        }

        window.addEventListener("resize", handleWindowSizeChange);
        
        handleWindowSizeChange();
        return () => window.removeEventListener("resize", handleWindowSizeChange);
    }, []);

    return width <= 640;
}

export function IsOnResize() {
    const [windowResizing, setWindowResizing] = useState(false);

    useEffect(() => {
      let timeout;
      const handleResize = () => {
        clearTimeout(timeout);
  
        setWindowResizing(true);
  
        timeout = setTimeout(() => {
          setWindowResizing(false);
        }, 200);
      }
      window.addEventListener("resize", handleResize);
  
      return () => window.removeEventListener("resize", handleResize);
    }, []);
  
    return <div>{JSON.stringify({ windowResizing })}</div>;
}

export function isHTML(str) {
  if(typeof document != 'undefined' && document) {
    var a = document.createElement('div');
    a.innerHTML = str;
    for (var c = a.childNodes, i = c.length; i--; ) {
      if (c[i].nodeType == 1) return true; 
    }
    return false;
  }
}

export const GenerateIdForGA = (componentName, action) => {
  let returnValue;
  const [currentSite, setCurrentSite] = useState(null);
  const [currentPage, setCurrentPage] = useState(null);
  const [isInModal, setIsInModal] = useState(false);
  const [modalName, setModalName] = useState(null);
  useEffect(() => {
    setCurrentSite(document.getElementById('currentSite').innerHTML);
    setCurrentPage(document.getElementById('currentPage').innerHTML);
    if(document.body.classList.contains('ReactModal__Body--open')) {
      setIsInModal(true);
      let input: any = document.getElementById('modalName');
      if(input) {
        setModalName(input.value);
      }
    }
  }, []);
  returnValue = `${currentSite}_${currentPage}_${componentName}_${action}`.replace(/ /g,'');
  if (isInModal) {
    returnValue += `_isInAModal_${modalName}`;
  }
  return returnValue;
}